export default __webpack_public_path__ + "static/media/pic5.e1eabbe7.png";